import React from 'react'

export default class InstructionBox extends React.Component {

  render() {
    const {children} = this.props
    return (
        <div className="instruction-box">
          {children}
        </div>
    )
  }
}